import { createAction, props } from '@ngrx/store';
import { ITradeSlim, TradeStatus, ITradeSubmit } from '@shared/models';

export enum ActionTypes {
  Load                = '[Trades] Load',
  LoadSuccess         = '[Trades] Load Success',
  LoadFail            = '[Trades] Load Fail',
  Add                 = '[Trades] Add',
  LoadPerOrganization = '[Trades] Load Per Organization'
}

export const load = createAction(
  ActionTypes.Load,
  props<{ status: TradeStatus }>()
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ trades: ITradeSlim[] }>()
);

export const loadFail = createAction(
  ActionTypes.LoadFail,
  props<{ error: string }>()
);

export const add = createAction(
  ActionTypes.Add,
  props<{ trade: ITradeSlim }>()
);

export const loadPerOrganization = createAction(
  ActionTypes.LoadPerOrganization,
  props<{ status: TradeStatus }>()
);


